/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-shadow */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable no-param-reassign */
// @ts-nocheck
import React, { useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core';
import { clone } from '../../utils/functions';
import { appActions } from '../../commons/reducer';
import { receiptsActions } from './reducer';
import connectSaga from '../../utils/saga';
import ReceiptsComponent from './components';
import saga from './saga';
import { ReactReduxContext } from '../../config/configureStore';
import { selectState, actionProps } from '../../utils/reduxActions';
import getQueryParams from '../../utils/services/getQueryParams';
import styles from './styles';
import { useAutomation } from '../../utils/hooks/useAutomationPermission';
import { shouldUseCallOffInAutomationModals } from '../../utils/tenantFeatures';

const useStyles = makeStyles(styles);

// Header list moved inside component to use translations

const defaultFilters = {
  // TODO: CAMBIAR A MES POSTERIOR DE OPTIMIZAR LA PAGINACIÓN EN EL BACKEND.
  fromDate: moment().subtract(2, 'days').startOf('day').toISOString(),
  toDate: moment().endOf('day').toISOString(),
  // fromDate: moment().startOf('month').toISOString(),
  // toDate: moment().endOf('month').toISOString(),
  paddockId: '',
  lotNumber: '',
  callOff: '',
  dispatchOrderNumber: '',
  supplierId: '',
  harvester: '',
  harvestDate: null,
  clientId: '',
  productId: '',
  varietyId: '',
  fruitId: '',
};

const defaultPagination = {
  page: 0,
  rowsPerPage: 10,
  count: 0,
};

function Receipts(props) {
  const { actions, loading, deleteIsOpen, pagination, toDeleteId } = props;
  const { t } = useTranslation();
  const { hasAutomation } = useAutomation();
  const shouldShowCallOffColumn =
    hasAutomation && shouldUseCallOffInAutomationModals();

  const headerList = useMemo(() => [
    { name: shouldShowCallOffColumn ? 'CallOff' : t('receipts.headers.lot'), width: '7%', mobileOrder: 1 },
    { name: t('receipts.headers.dispatch'), width: '8%', mobileOrder: 2 },
    { name: t('receipts.headers.entryDate'), width: '10%', mobileOrder: 3 },
    { name: t('receipts.headers.supplier'), width: '10%', mobileOrder: 4 },
    { name: t('receipts.headers.product'), width: '10%', mobileOrder: 5 },
    { name: t('receipts.headers.kilos'), width: '10%', mobileOrder: 6 },
    { name: t('receipts.headers.paddock'), width: '10%', mobileOrder: 7 },
    { name: t('receipts.headers.internalClient'), width: '10%', mobileOrder: 8 },
    { name: t('receipts.headers.harvester'), width: '10%', mobileOrder: 9 },
    { name: t('receipts.headers.harvest'), width: '10%', mobileOrder: 10 },
    { name: '', width: '5%', mobileOrder: 11 },
  ], [shouldShowCallOffColumn, t]);

  const [anchorEl, setAnchorEl] = useState(null);
  useEffect(() => {
    const params = getQueryParams();
    const newFilters = { ...defaultFilters };

    if (shouldShowCallOffColumn && params.callOff) {
      newFilters.callOff = params.callOff.split(',');
    } else if (params.lotNumber) {
      newFilters.lotNumber = params.lotNumber.split(',');
    }
    actions.changeFilters(newFilters);
    actions.getStateFromApi(newFilters, defaultPagination);
  }, [actions, shouldShowCallOffColumn]);

  function handleClick(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  function toggleForm() {
    actions.toggleForm('formIsOpen');
  }

  function closeForm() {
    actions.toggleForm('deleteIsOpen');
  }

  function submitDelete() {
    actions.deleteReceipt(toDeleteId);
  }

  const classes = useStyles();

  return (
    <ReceiptsComponent
      classes={classes}
      toggleForm={toggleForm}
      actions={actions}
      deleteIsOpen={deleteIsOpen}
      closeForm={closeForm}
      submitDelete={submitDelete}
      anchorEl={anchorEl}
      handleClick={handleClick}
      handleClose={handleClose}
      pagination={pagination}
      loading={loading}
      toggleDeleteLot={actions.toggleDeleteLot}
      defaultFilters={defaultFilters}
      defaultPagination={defaultPagination}
      headerList={headerList}
    />
  );
}

const withSaga = connectSaga({ key: 'sagaReceipts', saga });

const withConnect = connect(
  selectState(
    'receipts.deleteIsOpen',
    'receipts.toDeleteId',
    'receipts.pagination',
    'receipts.loading',
    'app.device',
    'app.account',
  ),
  actionProps(clone(clone.OBJECT, receiptsActions, appActions)),
  null,
  { context: ReactReduxContext },
);

export default compose(withStyles(styles), withRouter, withConnect)(withSaga(Receipts));
